import { __decorate } from "tslib";
import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
/**
 * Nested Checkbox (two-level multi-checkbox)
 * @author Jan Canicon <jan@gorated.ph>
 *                     <jancanicon.work@gmail.com>
 * @since Version {2.21.0}
 *
 * Docs: https://gorated.atlassian.net/wiki/spaces/DMDS/pages/1856143582/Nested+Checkbox
 */
let NestedCheckbox = class NestedCheckbox extends Mixins(ViewportSizeMixin) {
    constructor() {
        super(...arguments);
        this.expanded = null;
        this.isAllSelected = false;
        this.selectedOptions = [];
    }
    onOptionUpdate() {
        this.value.secondaryOptions = this.selectedOptions;
        this.isAllSelected = this.value.secondaryOptions.length === this.secondaryOptions.length;
        // Check primary option if coming from unchecked state
        if (!this.value.primaryOption) {
            this.value.primaryOption = true;
        }
        // Uncheck primary option if unchecked last secondary option
        if (this.selectedOptions.length === 0) {
            this.value.primaryOption = false;
        }
    }
    onPrimaryOptionClick() {
        this.$emit('touch');
        // If not yet selected or expanded
        if (!this.value.primaryOption && this.expanded !== 0) {
            this.expanded = 0;
        }
        // If not yet selected but expanded
        else if (!this.value.primaryOption && this.expanded === 0) {
            this.value.primaryOption = true;
            this.selectedOptions = this.secondaryOptions;
        }
        // If some suboptions are selected, reselect them all
        else if (!this.isAllSelected) {
            this.selectedOptions = this.secondaryOptions;
            this.expanded = 0;
        }
        // If all suboptions selected, deselect all
        else {
            this.value.primaryOption = false;
            this.selectedOptions = [];
            this.expanded = null;
        }
    }
    mounted() {
        this.selectedOptions = this.value.secondaryOptions;
        this.isAllSelected = this.value.secondaryOptions.length === this.secondaryOptions.length;
    }
};
__decorate([
    Prop({ type: Object, default: null })
], NestedCheckbox.prototype, "value", void 0);
__decorate([
    Prop({ type: String, default: 'Merchant Category' })
], NestedCheckbox.prototype, "primaryOption", void 0);
__decorate([
    Prop({ type: Array, default: () => [] })
], NestedCheckbox.prototype, "secondaryOptions", void 0);
__decorate([
    Watch('selectedOptions', { deep: true })
], NestedCheckbox.prototype, "onOptionUpdate", null);
NestedCheckbox = __decorate([
    Component
], NestedCheckbox);
export default NestedCheckbox;
